export const COLOR_PICKER_RECENT_PALETTE = "colorPicker.recentPalette";
export const ICON_EDITOR_PREVIEW_TOKEN = "iconEditorPreview.token";
export const ICON_EDITOR_PREVIEW_SHAPE = "iconEditorPreview.shape";
export const ICON_DOWNLOAD_SIZE = "iconDownload.size";

export const resetLocalStorage = () => {
    localStorage.removeItem(COLOR_PICKER_RECENT_PALETTE);
    localStorage.removeItem(ICON_EDITOR_PREVIEW_TOKEN);
    localStorage.removeItem(ICON_EDITOR_PREVIEW_SHAPE);
    localStorage.removeItem(ICON_DOWNLOAD_SIZE);
};
